import { getLoggedInUser } from "../helper-functions/userUtils";
import { API_URL, API_TOKEN } from "./sys";

export const get = async (
  endpoint: string, 
  params?: Record<string, string>,
): Promise<any> => {
  const url = new URL(`${API_URL}${endpoint}`);
  if (params) {
    Object.entries(params).forEach(([key, value]) =>
      url.searchParams.append(key, value)
    );
  }

  const headers: Record<string, string> = {
    "Accept": 'application/json',
    "countryCode": 'ID',
    "X-Api-Key": `${API_TOKEN}`,
    "loggedInUser": getLoggedInUser() || ''
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers
    });

    if (response.ok) {
      if (response.status === 204) {
        console.log("No content returned from the server.");
        return null;
      } else if (response.status === 200) {
        const data = await response.json();
        return data;
      } else {
        const errorText = await response.text();
        throw new Error(`HTTP error ${response.status}: ${errorText}`);
      }
    } else {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
      throw new Error(`HTTP error ${response.status}: ${errorText}`);
    }
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const post = async (
  endpoint: string, 
  data: any, 
): Promise<any> => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  if (response.ok) {
    console.log("REQUEST FINE");
    return responseData;
  } else {
    if (
      responseData.message === "Failed to create retailer" &&
      response.status === 500
    ) {
      window.alert(
        "A survey is already under progress/completed for this user, please contact your Admin for more info"
      );
      return;
    } else if (response.status === 409) {
      return { ...responseData, status: response.status };
    } else {
      window.alert("Something went Wrong!");
      return;
    }
  }
};

export const put = async (
  endpoint: string, 
  data: any, 
): Promise<any> => {
  const headers: Record<string, string> = {
    "Accept": '*/*',
    "Content-Type": "application/json",
    "X-Api-Key": `${API_TOKEN}`,
    "loggedInUser": getLoggedInUser() || ''
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    method: "PUT",
    headers,
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  if (response.ok) {
    console.log("REQUEST FINE");
    return responseData;
  } else {
    if (
      responseData.message === "Failed to create retailer" &&
      response.status === 500
    ) {
      window.alert(
        "A survey is already under progress/completed for this user, please contact your Admin for more info"
      );
      return;
    } else if (response.status === 409) {
      return { ...responseData, status: response.status };
    } else {
      window.alert(responseData.message ||"Something went Wrong!");
      return;
    }
  }
};